import React from 'react';

const VivLogo = ({ size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 350 350"
    fill="currentColor"
    {...props}
  >
    <circle cx="175" cy="175" r="175" fill="#eff4e5"/>
    <g>
      <polygon fill="#a59063" points="89.72 141.11 54.79 141.11 103.03 224.67 120.5 194.42 89.72 141.11"/>
      <polygon fill="#a59063" points="116.35 141.11 109.13 167.26 136.18 167.26 151.27 141.11 116.35 141.11"/>
      <polygon fill="#a59063" points="233.77 141.11 198.84 141.11 247.08 224.67 264.55 194.42 233.77 141.11"/>
      <polygon fill="#a59063" points="260.4 141.11 253.18 167.26 280.23 167.26 295.33 141.11 260.4 141.11"/>
      <rect fill="#a59063" x="159.43" y="141.11" width="31.14" height="83.56"/>
    </g>
  </svg>
);

export default VivLogo;